export const devMod = false;

function logDev(...paramtros) {
    const aux = '';
}

export const MLog = { print: devMod ? console.log : logDev };
